module.exports = __webpack_public_path__ + "img/about-us.5cd4677.png";